document.addEventListener("click", (e) => {
  const trigger = e.target.closest('[data-trigger="search-drawer"]');
  if (!trigger) return;

  // Kald focus synkront — iOS/Android kræver det er direkte i click-handleren
  const input = document.querySelector("#Search");
  if (input) {
    input.focus();
    input.select?.();
  }
});